import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Container, Typography, TextField, Button, Box, Grid } from "@mui/material";
import axios from "axios";

const Detail = () => {
  const { id } = useParams(); // Lấy ID từ URL
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  // Trạng thái các trường để chỉnh sửa - updated to match new API structure
  const [tenDuAn, setTenDuAn] = useState("");
  const [tenVietTat, setTenVietTat] = useState("");
  const [capDaoTao, setCapDaoTao] = useState("");
  const [donViSuNghiep, setDonViSuNghiep] = useState("");
  const [nhomNganhDaoTao, setNhomNganhDaoTao] = useState("");
  const [heThongCacCoSo, setHeThongCacCoSo] = useState("");
  const [trucThuocYTe, setTrucThuocYTe] = useState("");
  const [tuyenYTe, setTuyenYTe] = useState("");
  const [loaiCoSoYTe, setLoaiCoSoYTe] = useState("");
  const [chuDauTu, setChuDauTu] = useState("");
  const [congTyQuanLy, setCongTyQuanLy] = useState("");
  const [loaiHinhBds, setLoaiHinhBds] = useState("");
  const [hienTrang, setHienTrang] = useState("");
  const [namThanhLap, setNamThanhLap] = useState("");
  const [diaChiGop, setDiaChiGop] = useState("");
  const [diaChi, setDiaChi] = useState("");
  const [phuongXa, setPhuongXa] = useState("");
  const [quanHuyen, setQuanHuyen] = useState("");
  const [tinh, setTinh] = useState("");
  const [kinhDo, setKinhDo] = useState("");
  const [viDo, setViDo] = useState("");
  const [khachHang, setKhachHang] = useState("");
  const [thongTinLienHe, setThongTinLienHe] = useState("");
  const [tienDoTiepCan, setTienDoTiepCan] = useState("");
  const [dichVuTiepCan, setDichVuTiepCan] = useState("");
  const [thoiGianTiepCan, setThoiGianTiepCan] = useState("");
  const [chiTietTiepCan, setChiTietTiepCan] = useState("");
  const [giaBan, setGiaBan] = useState("");
  const [dienTichDat, setDienTichDat] = useState("");
  const [soCanHo, setSoCanHo] = useState("");
  const [soThap, setSoThap] = useState("");
  const [hang, setHang] = useState("");
  const [soTangNoi, setSoTangNoi] = useState("");
  const [soTangHam, setSoTangHam] = useState("");
  const [dienTichXayDung, setDienTichXayDung] = useState("");
  const [gfa, setGFA] = useState("");
  const [tongDienTichTangHam, setTongDienTichTangHam] = useState("");
  const [nfa, setNFA] = useState("");
  const [dienTichVpOfficeArea, setDienTichVpOfficeArea] = useState("");
  const [dienTichTm, setDienTichTm] = useState("");
  const [dienTichDeO, setDienTichDeO] = useState("");
  const [congTyXayDung, setCongTyXayDung] = useState("");
  const [congTyThietKe, setCongTyThietKe] = useState("");
  const [congTyGiamSatXayDung, setCongTyGiamSatXayDung] = useState("");
  const [banQuanTri, setBanQuanTri] = useState("");
  const [ghiChu, setGhiChu] = useState("");

  const fetchData = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_HOST_API}/bds/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      });
      setData(response.data.data);

      // Đặt các giá trị cho các trường - updated field names
      setTenDuAn(response.data.data.ten_du_an || "");
      setTenVietTat(response.data.data.ten_viet_tat || "");
      setCapDaoTao(response.data.data.cap_dao_tao || "");
      setDonViSuNghiep(response.data.data.don_vi_su_nghiep || "");
      setNhomNganhDaoTao(response.data.data.nhom_nganh_dao_tao || "");
      setHeThongCacCoSo(response.data.data.he_thong_cac_co_so || "");
      setTrucThuocYTe(response.data.data.truc_thuoc_y_te || "");
      setTuyenYTe(response.data.data.tuyen_y_te || "");
      setLoaiCoSoYTe(response.data.data.loai_co_so_y_te || "");
      setChuDauTu(response.data.data.chu_dau_tu || "");
      setCongTyQuanLy(response.data.data.cong_ty_quan_ly || "");
      setLoaiHinhBds(response.data.data.loai_hinh_bds || "");
      setHienTrang(response.data.data.hien_trang || "");
      setNamThanhLap(response.data.data.nam_thanh_lap || "");
      setDiaChiGop(response.data.data.dia_chi_gop || "");
      setDiaChi(response.data.data.dia_chi || "");
      setPhuongXa(response.data.data.phuong_xa || "");
      setQuanHuyen(response.data.data.quan_huyen || "");
      setTinh(response.data.data.tinh || "");
      setKinhDo(response.data.data.kinh_do || "");
      setViDo(response.data.data.vi_do || "");
      setKhachHang(response.data.data.khach_hang || "");
      setThongTinLienHe(response.data.data.thong_tin_lien_he || "");
      setTienDoTiepCan(response.data.data.tien_do_tiep_can || "");
      setDichVuTiepCan(response.data.data.dich_vu_tiep_can || "");
      setThoiGianTiepCan(response.data.data.thoi_gian_tiep_can || "");
      setChiTietTiepCan(response.data.data.chi_tiet_tiep_can || "");
      setGiaBan(response.data.data.gia_ban || "");
      setDienTichDat(response.data.data.dien_tich_dat || "");
      setSoCanHo(response.data.data.so_can_ho || "");
      setSoThap(response.data.data.so_thap || "");
      setHang(response.data.data.hang || "");
      setSoTangNoi(response.data.data.so_tang_noi || "");
      setSoTangHam(response.data.data.so_tang_ham || "");
      setDienTichXayDung(response.data.data.dien_tich_xay_dung || "");
      setGFA(response.data.data.gfa || "");
      setTongDienTichTangHam(response.data.data.tong_dien_tich_tang_ham || "");
      setNFA(response.data.data.nfa || "");
      setDienTichVpOfficeArea(response.data.data.dien_tich_vp_office_area || "");
      setDienTichTm(response.data.data.dien_tich_tm || "");
      setDienTichDeO(response.data.data.dien_tich_de_o || "");
      setCongTyXayDung(response.data.data.cong_ty_xay_dung || "");
      setCongTyThietKe(response.data.data.cong_ty_thiet_ke || "");
      setCongTyGiamSatXayDung(response.data.data.cong_ty_giam_sat_xay_dung || "");
      setBanQuanTri(response.data.data.ban_quan_tri || "");
      setGhiChu(response.data.data.ghi_chu || "");

      setLoading(false);
    } catch (error) {
      setError("Failed to fetch data");
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [id]);

  const handleUpdate = async () => {
    try {
      const data = {
        ten_du_an: tenDuAn,
        ten_viet_tat: tenVietTat,
        cap_dao_tao: capDaoTao,
        don_vi_su_nghiep: donViSuNghiep,
        nhom_nganh_dao_tao: nhomNganhDaoTao,
        he_thong_cac_co_so: heThongCacCoSo,
        truc_thuoc_y_te: trucThuocYTe,
        tuyen_y_te: tuyenYTe,
        loai_co_so_y_te: loaiCoSoYTe,
        chu_dau_tu: chuDauTu,
        cong_ty_quan_ly: congTyQuanLy,
        loai_hinh_bds: loaiHinhBds,
        hien_trang: hienTrang,
        nam_thanh_lap: namThanhLap,
        dia_chi_gop: diaChiGop,
        dia_chi: diaChi,
        phuong_xa: phuongXa,
        quan_huyen: quanHuyen,
        tinh: tinh,
        kinh_do: kinhDo,
        vi_do: viDo,
        khach_hang: khachHang,
        thong_tin_lien_he: thongTinLienHe,
        tien_do_tiep_can: tienDoTiepCan,
        dich_vu_tiep_can: dichVuTiepCan,
        thoi_gian_tiep_can: thoiGianTiepCan,
        chi_tiet_tiep_can: chiTietTiepCan,
        gia_ban: giaBan,
        dien_tich_dat: dienTichDat,
        so_can_ho: soCanHo || 0,
        so_thap: soThap || 0,
        hang: hang,
        so_tang_noi: soTangNoi || 0,
        so_tang_ham: soTangHam || 0,
        dien_tich_xay_dung: dienTichXayDung,
        gfa: gfa,
        tong_dien_tich_tang_ham: tongDienTichTangHam,
        nfa: nfa,
        dien_tich_vp_office_area: dienTichVpOfficeArea,
        dien_tich_tm: dienTichTm,
        dien_tich_de_o: dienTichDeO,
        cong_ty_xay_dung: congTyXayDung,
        cong_ty_thiet_ke: congTyThietKe,
        cong_ty_giam_sat_xay_dung: congTyGiamSatXayDung,
        ban_quan_tri: banQuanTri,
        ghi_chu: ghiChu,
      };
      await axios.put(
        `${process.env.REACT_APP_HOST_API}/bds/update/${id}`,
        {
          data,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        }
      );
      navigate("/home"); // Quay lại trang chính sau khi cập nhật
    } catch (error) {
      setError("Failed to update data");
    }
  };

  const handleChange = (setter) => (event) => {
    setter(event.target.value);
  };

  if (loading) return <Typography>Loading...</Typography>;
  if (error) return <Typography>{error}</Typography>;

  return (
    <Container maxWidth="lg">
      <Typography variant="h4" gutterBottom>
        Chi tiết Dự án
      </Typography>
      <Box sx={{ mt: 2 }}>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <TextField label="Tên dự án" variant="outlined" fullWidth margin="normal" value={tenDuAn} onChange={handleChange(setTenDuAn)} />
          </Grid>
          <Grid item xs={6}>
            <TextField label="Tên viết tắt" variant="outlined" fullWidth margin="normal" value={tenVietTat} onChange={handleChange(setTenVietTat)} />
          </Grid>
          <Grid item xs={6}>
            <TextField label="Cấp đào tạo" variant="outlined" fullWidth margin="normal" value={capDaoTao} onChange={handleChange(setCapDaoTao)} />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Đơn vị sự nghiệp"
              variant="outlined"
              fullWidth
              margin="normal"
              value={donViSuNghiep}
              onChange={handleChange(setDonViSuNghiep)}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Nhóm ngành đào tạo"
              variant="outlined"
              fullWidth
              margin="normal"
              value={nhomNganhDaoTao}
              onChange={handleChange(setNhomNganhDaoTao)}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Hệ thống các cơ sở"
              variant="outlined"
              fullWidth
              margin="normal"
              value={heThongCacCoSo}
              onChange={handleChange(setHeThongCacCoSo)}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Trực thuộc y tế"
              variant="outlined"
              fullWidth
              margin="normal"
              value={trucThuocYTe}
              onChange={handleChange(setTrucThuocYTe)}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField label="Tuyến y tế" variant="outlined" fullWidth margin="normal" value={tuyenYTe} onChange={handleChange(setTuyenYTe)} />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Loại cơ sở y tế"
              variant="outlined"
              fullWidth
              margin="normal"
              value={loaiCoSoYTe}
              onChange={handleChange(setLoaiCoSoYTe)}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField label="Chủ đầu tư" variant="outlined" fullWidth margin="normal" value={chuDauTu} onChange={handleChange(setChuDauTu)} />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Công ty quản lý"
              variant="outlined"
              fullWidth
              margin="normal"
              value={congTyQuanLy}
              onChange={handleChange(setCongTyQuanLy)}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Loại hình BDS"
              variant="outlined"
              fullWidth
              margin="normal"
              value={loaiHinhBds}
              onChange={handleChange(setLoaiHinhBds)}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField label="Hiện trạng" variant="outlined" fullWidth margin="normal" value={hienTrang} onChange={handleChange(setHienTrang)} />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Năm thành lập"
              variant="outlined"
              fullWidth
              margin="normal"
              value={namThanhLap}
              onChange={handleChange(setNamThanhLap)}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField label="Địa chỉ gộp" variant="outlined" fullWidth margin="normal" value={diaChiGop} onChange={handleChange(setDiaChiGop)} />
          </Grid>
          <Grid item xs={6}>
            <TextField label="Địa chỉ" variant="outlined" fullWidth margin="normal" value={diaChi} onChange={handleChange(setDiaChi)} />
          </Grid>
          <Grid item xs={6}>
            <TextField label="Phường/Xã" variant="outlined" fullWidth margin="normal" value={phuongXa} onChange={handleChange(setPhuongXa)} />
          </Grid>
          <Grid item xs={6}>
            <TextField label="Quận/Huyện" variant="outlined" fullWidth margin="normal" value={quanHuyen} onChange={handleChange(setQuanHuyen)} />
          </Grid>
          <Grid item xs={6}>
            <TextField label="Tỉnh/Thành phố" variant="outlined" fullWidth margin="normal" value={tinh} onChange={handleChange(setTinh)} />
          </Grid>
          <Grid item xs={6}>
            <TextField label="Kinh độ" variant="outlined" fullWidth margin="normal" value={kinhDo} onChange={handleChange(setKinhDo)} />
          </Grid>
          <Grid item xs={6}>
            <TextField label="Vĩ độ" variant="outlined" fullWidth margin="normal" value={viDo} onChange={handleChange(setViDo)} />
          </Grid>
          <Grid item xs={6}>
            <TextField label="Khách hàng" variant="outlined" fullWidth margin="normal" value={khachHang} onChange={handleChange(setKhachHang)} />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Thông tin liên hệ"
              variant="outlined"
              fullWidth
              margin="normal"
              value={thongTinLienHe}
              onChange={handleChange(setThongTinLienHe)}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Tiến độ tiếp cận"
              variant="outlined"
              fullWidth
              margin="normal"
              value={tienDoTiepCan}
              onChange={handleChange(setTienDoTiepCan)}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Dịch vụ tiếp cận"
              variant="outlined"
              fullWidth
              margin="normal"
              value={dichVuTiepCan}
              onChange={handleChange(setDichVuTiepCan)}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Thời gian tiếp cận"
              variant="outlined"
              fullWidth
              margin="normal"
              value={thoiGianTiepCan}
              onChange={handleChange(setThoiGianTiepCan)}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Chi tiết tiếp cận"
              variant="outlined"
              fullWidth
              margin="normal"
              value={chiTietTiepCan}
              onChange={handleChange(setChiTietTiepCan)}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField label="Giá bán" variant="outlined" fullWidth margin="normal" value={giaBan} onChange={handleChange(setGiaBan)} />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Diện tích đất"
              variant="outlined"
              fullWidth
              margin="normal"
              value={dienTichDat}
              onChange={handleChange(setDienTichDat)}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField label="Số căn hộ" variant="outlined" fullWidth margin="normal" value={soCanHo} onChange={handleChange(setSoCanHo)} />
          </Grid>
          <Grid item xs={6}>
            <TextField label="Số tháp" variant="outlined" fullWidth margin="normal" value={soThap} onChange={handleChange(setSoThap)} />
          </Grid>
          <Grid item xs={6}>
            <TextField label="Hạng" variant="outlined" fullWidth margin="normal" value={hang} onChange={handleChange(setHang)} />
          </Grid>
          <Grid item xs={6}>
            <TextField label="Số tầng nổi" variant="outlined" fullWidth margin="normal" value={soTangNoi} onChange={handleChange(setSoTangNoi)} />
          </Grid>
          <Grid item xs={6}>
            <TextField label="Số tầng hầm" variant="outlined" fullWidth margin="normal" value={soTangHam} onChange={handleChange(setSoTangHam)} />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Diện tích xây dựng"
              variant="outlined"
              fullWidth
              margin="normal"
              value={dienTichXayDung}
              onChange={handleChange(setDienTichXayDung)}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField label="GFA" variant="outlined" fullWidth margin="normal" value={gfa} onChange={handleChange(setGFA)} />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Tổng diện tích tầng hầm"
              variant="outlined"
              fullWidth
              margin="normal"
              value={tongDienTichTangHam}
              onChange={handleChange(setTongDienTichTangHam)}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField label="NFA" variant="outlined" fullWidth margin="normal" value={nfa} onChange={handleChange(setNFA)} />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Diện tích VP (Office Area)"
              variant="outlined"
              fullWidth
              margin="normal"
              value={dienTichVpOfficeArea}
              onChange={handleChange(setDienTichVpOfficeArea)}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Diện tích thương mại"
              variant="outlined"
              fullWidth
              margin="normal"
              value={dienTichTm}
              onChange={handleChange(setDienTichTm)}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Diện tích để ở"
              variant="outlined"
              fullWidth
              margin="normal"
              value={dienTichDeO}
              onChange={handleChange(setDienTichDeO)}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Công ty xây dựng"
              variant="outlined"
              fullWidth
              margin="normal"
              value={congTyXayDung}
              onChange={handleChange(setCongTyXayDung)}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Công ty thiết kế"
              variant="outlined"
              fullWidth
              margin="normal"
              value={congTyThietKe}
              onChange={handleChange(setCongTyThietKe)}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Công ty giám sát xây dựng"
              variant="outlined"
              fullWidth
              margin="normal"
              value={congTyGiamSatXayDung}
              onChange={handleChange(setCongTyGiamSatXayDung)}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField label="Ban quản trị" variant="outlined" fullWidth margin="normal" value={banQuanTri} onChange={handleChange(setBanQuanTri)} />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Ghi chú"
              variant="outlined"
              fullWidth
              multiline
              rows={4}
              margin="normal"
              value={ghiChu}
              onChange={handleChange(setGhiChu)}
            />
          </Grid>
          <Grid item xs={12}>
            <Button variant="contained" color="primary" onClick={handleUpdate}>
              Cập nhật
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};

export default Detail;
